import React, { Component } from 'react';
import { compose, withHandlers, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Clear from '@material-ui/icons/Clear';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';

import { toggleAddUserPopup, toggleAddUserPopupSuccess, resetUser } from '../../redux/reducers/view';

import Popup from '../Popup';
import AddUserForm from '../Form/AddUserForm';

import { COLORS, commonStyles } from '../../styles/styles';
import addUserImage from '../../assets/add_user.svg';
import addUserSuccessImage from '../../assets/message_sent.svg';
import { Field, reduxForm, reset } from 'redux-form';
import { addUserRequest, resetAddUserForm, getUserRolloutRequest } from '../../redux/reducers/addUser';
import AddUserEmailField from '../Form/AddUserEmailField';
import { validateAddUser } from '../Form/validate';
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBNotification, MDBIcon, MDBAlert } from 'mdbreact';
import Dropdown from '../Form/Dropdown';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { ScaleLoader } from 'react-spinners';


class AddUserPopup extends Component {
  state = {
    modal: true
  };

  toggle = () => {
    this.props.resetUser();
    this.props.resetAddUserForm()
    this.props.resetForm('addUserForm');
    this.props.toggleAddUserPopup(false)
  }
  render() {
    return (
      <div>{this.props.showAddUser &&
      <MDBContainer>
        <MDBModal isOpen={this.props.showAddUser} toggle={this.toggle}  centered  >
          <MDBModalHeader toggle={this.toggle} className="default-color text-white">Add User</MDBModalHeader>
          <form onSubmit={this.props.handleSubmit(this.props.handleSubmitAddUser)}>
          <MDBModalBody>
         
          <Field name="Email" label="User to invite" component={Dropdown} options={this.props.addUser.users}  />
          {this.props.addUser.error &&  <div style={{margin:5}}><MDBAlert color="danger" dismiss >
          <MDBIcon icon="exclamation-circle" /><strong> Error</strong> This email address does not exist!
          </MDBAlert></div>}
      {this.props.view.addUserPopupSuccess && <div style={{margin:5}}><MDBAlert color="success" dismiss >
          <MDBIcon icon="check-circle" /><strong> Success</strong> Invitation has been sent successfully!
          </MDBAlert></div>}
 
          </MDBModalBody>
          <MDBModalFooter>
          <MDBBtn className="btn-grey" size="md" type='submit'>Add User</MDBBtn> <MDBBtn className="btn-dark-green" size="md" onClick={this.toggle}>Close</MDBBtn>
          </MDBModalFooter>
          </form>
          <ReactCSSTransitionGroup
          transitionName="fade"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}>{this.props.addUser.fetching==true && <div onClick={(e)=>e.stopPropagation() } style={{pointerEvents:'all',backgroundColor:'#FFFFFF', position:'absolute', top:0, left:0, height:'100%', width:'100%', zIndex:12000, textAlign:'center'}}>
          <div style={{position:'absolute', top:"40%", width:'100%'}}>
        <ScaleLoader
         
         height={35}
         width={4}
         radius={2}
         margin='2px'
         color={COLORS.cornerstoneRed}
         loading={true}
       />
       </div>
        </div>}</ReactCSSTransitionGroup>
        
        </MDBModal>
      
        
      </MDBContainer>}
      </div>
    );
  }
}

// const AddUserPopup = ({ classes, handleCloseAddUserPopup, view }) => (
//   <Popup>
//     <div className={classes.popup}>
//       <div className={`${classes.popupContent} ${classes.addUserPopupContent}`}>
//         <div className={classes.popupHeader}>
//           <Clear className={classes.closePopup} onClick={handleCloseAddUserPopup} />
//           <img
//             src={view.addUserPopupSuccess ? addUserSuccessImage : addUserImage}
//             alt="addUserImage"
//             className={classes.image}
//           />
//           <Typography variant="headline" gutterBottom className={classes.popupHeaderText}>
//             {view.addUserPopupSuccess ? 'Invitation has been sent successfully!' : 'Add a new team member'}
//           </Typography>
//         </div>
//         {!view.addUserPopupSuccess && (
//           <div className={classes.popupBody}>
//             <AddUserForm />
//           </div>
//         )}
//       </div>
//     </div>
//   </Popup>
// );

const styles = () => ({
  ...commonStyles,
  addUserPopupContent: {
    minHeight: 150,
  },
  image: {
    width: 64,
    height: 64,
  },
});


const mapDispatchToProps = dispatch => ({
  toggleAddUserPopup: value => dispatch(toggleAddUserPopup(value)),
  toggleAddUserPopupSuccess: value => dispatch(toggleAddUserPopupSuccess(value)),
  resetUser: value => dispatch(resetUser(value)),
  resetForm: value => dispatch(reset(value)),
  addUserRequest: () => dispatch(addUserRequest()),
  resetAddUserForm: () => dispatch(resetAddUserForm()),
  getUsersForRollout:() => dispatch(getUserRolloutRequest())
});

const mapStateToProps = state => ({
  view: state.viewReducer,
  showAddUser:state.viewReducer.addUserPopup,
  form: state.form,
  addUser: state.addUserReducer,
});

export default compose(
  reduxForm({
    form: 'addUserForm',
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  lifecycle({
    componentWillReceiveProps(nextProps) {
      const { view, toggleAddUserPopup, toggleAddUserPopupSuccess } = nextProps;
      console.log('GO NO GO', this.props.showAddUser)
      if(!this.props.showAddUser && nextProps.showAddUser){
        console.log('GO NO GO')
        this.props.getUsersForRollout()
      }
      // if (view.addUserPopupSuccess) {
      //   setTimeout(() => {
      //     toggleAddUserPopup(false);
      //     toggleAddUserPopupSuccess(false);
      //   }, 3000);
      // }
    },
    componentWillUnmount() {
      this.props.resetAddUserForm();
    },
  }),
  withHandlers({
    handleCloseAddUserPopup: props => () => {
      // props.toggleAddUserPopup(false);
      // props.toggleAddUserPopupSuccess(false);
    },
    handleSubmitAddUser: props => values => {
      props.resetAddUserForm();
      validateAddUser(values);
      props.addUserRequest();
    },
  }),

  withStyles(styles),
)(AddUserPopup);

AddUserPopup.propTypes = {
  handleSubmit: PropTypes.func,
  classes: PropTypes.instanceOf(Object),
  view: PropTypes.instanceOf(Object),
  handleCloseAddUserPopup: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/Components/Popups/AddUserPopup.jsx